
const _this = this;

export function initializeRazorpay(){
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";

    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };

    document.body.appendChild(script);
  });
};

const supportedPaymentGateways = ["razorpay"];
function startPayment(data) {
  switch (data.paymentMode) {
    case "razorpay":
      initiateRazorpayPayment(data);
      break;
  }
}

const initiateRazorpayPayment = async function(data) {
  const key = process.env.RAZORPAY_ID;
  var options = {
    key,
    order_id: data.razorpayOrderId,
    name: data.planName,
    amount: data.amount,
    description: data.description,
    image: data.logoImage,
    currency: data.currency,
    //offer_id: this.offer_id,
    handler: async response => {
      data.onPaymentSuccess(
        paymentSuccessResponseEncode({
          paymentMode: data.paymentMode,
          response
        })
      );
    },
    modal: {
      ondismiss: () => {
        data.onPaymentDismiss();
      }
    },
    prefill: {
      name: data.userName,
      email: data.userEmail,
      contact: data.userMobile
    },
    notes: {
      userInfo: {
        order: data.orderId,
        name: data.userName,
        email: data.userEmail,
        contact: data.userMobile
      }
    },
    theme: {
      color: "#F37254"
    }
  };
  const res = await initializeRazorpay();
  if (!res) {
    alert("Razorpay SDK Failed to load");
    return;
  }

  var rzp = new window.Razorpay(options);
  //registe error handler
  rzp.on("payment.failed", response => {
    data.onPaymentFailed();
  });
  rzp.open();
};

const paymentSuccessResponseEncode = function(data) {
  switch (data.paymentMode) {
    case "razorpay":
      return {
        paymentId: data.response.razorpay_payment_id,
        paymentMode: data.paymentMode
      };
  }
};

function getPaymentGatewayRequestData(data) {
  switch (data.paymentMode) {
    case "razorpay":
      const { order, description, logoImage } = data;
      return {
        paymentMode: "razorpay",
        orderId: order.id,
        razorpayOrderId: order.supportedPaymentOrder.id,
        amount: order.amount,
        description,
        logoImage,
        currency: order.currency,
        userName: order.first_name + " " + order.last_name,
        userEmail: order.email,
        userMobile: order.mobile,
        onPaymentSuccess: response => {
          data.onPaymentSuccess(response);
        },
        onPaymentDismiss: function() {
          data.onPaymentDismiss();
        },
        onPaymentFailed: function() {
          data.onPaymentFailed();
        }
      };
  }
}

export async function initiatePayment(data, options) {
  const { order, paymentMode, logoImage, description } = data;
  if (!supportedPaymentGateways.includes(data.paymentMode)) {
    throw new Error("payment gateway not supported");
  }
  const paymentRequest = getPaymentGatewayRequestData(data);
  startPayment(paymentRequest);
}
